<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'PEO,PSO,PO'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">PEO,PSO,PO</div>
            <Accordion :activeIndex="0">
              <AccordionTab header="Program Educational Objectives (PEOs)">
                <ul class="list-inside">
                  <li class="flex justify-start pb-2" v-for="(peo,index) in PEOS" :key="index">
                    <span class="font-semibold mr-2">{{ peo.title }}:</span>
                    <p>{{ peo.description }}</p>
                  </li>
                </ul>
              </AccordionTab>
              <AccordionTab header="Program Specific Outcomes (PSOs)">
                <ul class="list-inside">
                  <li class="flex justify-start pb-2"></li>
                </ul>
              </AccordionTab>
              <AccordionTab header="Program Outcomes (POs)">
                <ul class="list-inside">
                  <li class="flex flex-col justify-start pb-2" v-for="(po,index) in POS" :key="index">
                    <span class="font-semibold mr-2">{{ po.title }}:</span>
                    <p class="ml-10">{{ po.description }}</p>
                  </li>
                </ul>
              </AccordionTab>
            </Accordion>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "PosPeos",
  components: {
    NavbarComponent,KeyRecruiters,
    PageHeader,
    Sidebar,
    FooterComponent,
    Accordion,
    AccordionTab
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      div: null,
      PEOS: [
        {
          title: 'PEO1',
          description: ' Graduates of the MBA program will successfully integrate core, cross-functional and inter-disciplinary aspects of management theories, models and frameworks with the real world practices and the sector specific nuances to provide solutions to real world business, policy and social issues in a dynamic and complex world.'
        },
        {
          title: 'PEO2',
          description: 'Graduates of the MBA program will possess excellent communication skills, excel in cross-functional, multi-disciplinary, multi-cultural teams, and have an appreciation for local, domestic and global contexts so as to manage continuity, change, risk, ambiguity and complexity.'
        },
        {
          title: 'PEO3',
          description: 'Graduates of the MBA program will be appreciative of the significance of Indian ethos and values in managerial decision making and exhibit value centered leadership.'
        },
        {
          title: 'PEO4',
          description: 'Graduates of the MBA program will be ready to engage in successful career pursuits covering a broad spectrum of areas in corporate, non-profit organizations, public policy, entrepreneurial ventures and engage in life-long learning.'
        },
        {
          title: 'PEO5',
          description: ' Graduates of the MBA program will be recognized in their chosen fields for their managerial competence, creativity & innovation, integrity & sensitivity to local and global issues of social relevance and earn the trust & respect of others as inspiring, effective and ethical leaders, managers, entrepreneurs, entrepreneurs and change agents.'

        },],

      POS: [
        {
          title: 'PO1 - Generic and Domain Knowledge',
          description: 'Ability to articulate, illustrate, analyze, synthesize and apply the knowledge of principles and frameworks of management and allied domains to the solutions of real-world complex business issues'
        },
        {
          title: 'PO2 - Problem Solving & Innovation',
          description: 'Ability to Identify, formulate and provide innovative solution frameworks to real world complex business and social problems by systematically applying modern quantitative and qualitative problem solving tools and techniques. '
        },
        {
          title: 'PO3 - Critical Thinking',
          description: 'Ability to conduct investigation of multidimensional business problems using research based knowledge and research methods to arrive at data driven decisions'
        },
        {
          title: 'PO4 - Effective Communication',
          description: 'Ability to effectively communicate in cross-cultural settings, in technology mediated environments, especially in the business context and with society at large'
        },
        {
          title: 'PO5 - Leadership and Team Work',
          description: 'Ability to collaborate in an organizational context and across organizational boundaries and lead themselves and others in the achievement of organizational goals and optimize outcomes for all stakeholders.'
        },
        {
          title: 'PO6 - Global Orientation and Cross-Cultural Appreciation',
          description: 'Ability to approach any relevant business issues from a global perspective and exhibit an appreciation of Cross Cultural aspects of business and management.'
        },
        {
          title: 'PO7 - Entrepreneurship',
          description: 'Ability to identify entrepreneurial opportunities and leverage managerial & leadership skills for founding, leading & managing startups as well as professionalizing and growing family businesses.'
        },
        {
          title: 'PO8 - Environment and Sustainability',
          description: 'Ability to demonstrate knowledge of and need for sustainable development and assess the impact of managerial decisions and business priorities on the societal, economic and environmental aspects.'
        },
        {
          title: 'PO9 - Social Responsiveness and Ethics',
          description: 'Ability to exhibit a broad appreciation of the ethical and value underpinnings of managerial choices in a political, cross-cultural, globalized, digitized, socio-economic environment and distinguish between ethical and unethical behaviors & act with integrity.'
        },
        {
          title: 'PO10 - LifeLong Learning',
          description: ' Ability to operate independently in new environment, acquire new knowledge and skills and assimilate them into the internalized knowledge and skills.'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
